<template>

    <div class="column" v-if="dev || db.admin">
        <table>
            <tr v-for="(item, i) in items" :key="i">
                <td class="bold">{{ item.k }}</td>
                <td>{{ item.v }}</td>
            </tr>
        </table>
    </div>

<!-- 
    <JJ :raw="account"></JJ>
 -->
</template>
<script>
export default {
    data: function () {return {
        
    }},
    props:{
        raw:undefined,         
    },    
    
    computed: {
        items(){
            let res = []
            let data = this.raw
            console.log(typeof data)

            switch (typeof data) {
                case 'object':
                    for (var k in data){
                        let v = data[k]
                        res.push({k,v})
                    }
                    break;
                case 'array':                     
                    data.forEach(item => {
                        res.push({k:item})
                    });    
                break;            
                default:
                    break;
            }

            return res
        },        
    },
}
</script>
<style scoped>

</style>




















